/**
 * Return the supported image format by a browser
 * Falls back to PNG if eiither of AVIF or WEBP above are not supported
 *
 * @autor Alexander Ivanov <@alecsIV>
 * @async
 * @returns {string} supported image format ('avif', 'webp', 'png')
 */
const getSupportedImageFormat = async () => {
    const avif = await isFormatSupported('avif');
    const webp = await isFormatSupported('webp');

    return (avif) ? 'avif' : (webp) ? 'webp' : 'png';
};

/**
 * This function tests wether AVIF or WEBP are supported
 * @function
 * @param {string} format - 'avif' | 'webp'
 * @returns {Promise<string>} The supported image format coming from testing agains browser compatibility
 */
const isFormatSupported = async (format) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        if (format === 'avif') {
            image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A='; // the shortest data string for avif images (~300 bytes)
            image.onload = () => resolve(true);
        }
        else if (format === 'webp') {
            image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA='; // shortest data string for webp (~80 bytes)
            image.onload = () => resolve(image.width === 1);
        }
        image.onerror = () => reject();
    }).catch(() => false);
};

module.exports = getSupportedImageFormat;
